import React, { useState } from 'react';
import classNames from 'classnames';
import './checkbox_rounded.scss';

interface Props {
  dataTestId: string;
  icon?: string;
  iconChecked?: string;
  onClickHandler: () => React.MouseEvent<HTMLButtonElement>;
  checked: boolean;
}

const CheckboxRounded = ({
  dataTestId,
  icon = 'icon-plus',
  iconChecked = 'icon-check',
  onClickHandler,
  checked,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const onClickEvent = () => {
    setIsLoading(true);
    onClickHandler().finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <button
      data-testid={dataTestId}
      disabled={isLoading}
      className={classNames('react-checkbox-rounded btn btn-link', { checked: checked })}
      aria-label='Click'
      onClick={onClickEvent}
    >
      {isLoading ? (
        <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
      ) : checked ? (
        <i className={`icon fal ${iconChecked}`} data-testid='icon-checked'></i>
      ) : (
        <i className={`icon fal ${icon}`} data-testid='icon'></i>
      )}
    </button>
  );
};

export default CheckboxRounded;
